import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
    B2bAcceptance,
    B2bLcAccounting,
    B2bMaturitySchedule,
    CreateB2bAcceptancePaymentRequest,
    CreateB2bAcceptanceRequest,
    SetB2bMarginRequest,
} from '../interfaces/commercial.interface';

const E = ENDPOINTS.BACK_TO_BACK_LC;

/** B2B LC accounting (accounting wave 2): margin, bank acceptances, maturity payments, schedule. Data only. */
export const B2bAccountingService = {
    get: async (institutionId: string, lcId: string, b2bId: string): Promise<B2bLcAccounting> =>
        (await axios.get(E.ACCOUNTING(institutionId, lcId, b2bId))).data,

    setMargin: async (institutionId: string, lcId: string, b2bId: string, dto: SetB2bMarginRequest): Promise<B2bLcAccounting> =>
        (await axios.post(E.MARGIN(institutionId, lcId, b2bId), dto)).data,
    removeMargin: async (institutionId: string, lcId: string, b2bId: string): Promise<B2bLcAccounting> =>
        (await axios.delete(E.MARGIN(institutionId, lcId, b2bId))).data,
    releaseMargin: async (institutionId: string, lcId: string, b2bId: string, releaseDate: string): Promise<B2bLcAccounting> =>
        (await axios.post(E.MARGIN_RELEASE(institutionId, lcId, b2bId), { releaseDate })).data,
    reverseMarginRelease: async (institutionId: string, lcId: string, b2bId: string): Promise<B2bLcAccounting> =>
        (await axios.delete(E.MARGIN_RELEASE(institutionId, lcId, b2bId))).data,

    createAcceptance: async (institutionId: string, lcId: string, b2bId: string, dto: CreateB2bAcceptanceRequest): Promise<B2bAcceptance> =>
        (await axios.post(E.ACCEPTANCES(institutionId, lcId, b2bId), dto)).data,
    deleteAcceptance: async (institutionId: string, lcId: string, b2bId: string, acceptanceId: string): Promise<void> => {
        await axios.delete(E.ACCEPTANCE_ITEM(institutionId, lcId, b2bId, acceptanceId));
    },
    createPayment: async (
        institutionId: string, lcId: string, b2bId: string, acceptanceId: string, dto: CreateB2bAcceptancePaymentRequest,
    ): Promise<B2bAcceptance> =>
        (await axios.post(E.ACCEPTANCE_PAYMENTS(institutionId, lcId, b2bId, acceptanceId), dto)).data,
    deletePayment: async (
        institutionId: string, lcId: string, b2bId: string, acceptanceId: string, paymentId: string,
    ): Promise<B2bAcceptance> =>
        (await axios.delete(E.ACCEPTANCE_PAYMENT_ITEM(institutionId, lcId, b2bId, acceptanceId, paymentId))).data,

    getMaturitySchedule: async (institutionId: string, asOf?: string): Promise<B2bMaturitySchedule> =>
        (await axios.get(E.MATURITY_SCHEDULE(institutionId), { params: asOf ? { asOf } : undefined })).data,
};
